import { defineComponent as _defineComponent } from 'vue';
import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-1463b839"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "tip-context" };
const _hoisted_2 = { class: "icon-box" };
const _hoisted_3 = { class: "note-text bodyBase" };
import { ref } from "vue";
export default /*#__PURE__*/ _defineComponent({
    name: 'index',
    props: {
        size: { default: "default" },
        showClose: { type: Boolean, default: true }
    },
    setup(__props) {
        const show = ref(true);
        const closeHandle = () => {
            show.value = false;
        };
        return (_ctx, _cache) => {
            const _component_svg_icon = _resolveComponent("svg-icon");
            return (show.value)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: _normalizeClass(["tips-box", __props.size + '-padding'])
                }, [
                    _createElementVNode("div", _hoisted_1, [
                        _renderSlot(_ctx.$slots, "icon", {}, () => [
                            _createElementVNode("div", _hoisted_2, [
                                _createVNode(_component_svg_icon, {
                                    "icon-class": "info-notify",
                                    "class-name": "info-icon"
                                })
                            ])
                        ]),
                        _createElementVNode("p", _hoisted_3, [
                            _renderSlot(_ctx.$slots, "default")
                        ])
                    ]),
                    (__props.showClose)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            class: "close-icon-box",
                            onClick: closeHandle
                        }, [
                            _createVNode(_component_svg_icon, {
                                "icon-class": "close",
                                "class-name": "cursor-pointer"
                            })
                        ]))
                        : _createCommentVNode("", true)
                ], 2))
                : _createCommentVNode("", true);
        };
    }
});
